import _ from 'lodash';
import React, {Component} from 'react';
import {UnmountClosed} from 'react-collapse';
import clickOutside from 'react-click-outside';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import './Feature.css';


let dumbFeature = dumbBem('l-pricing-feature');
let FeatureWrp = tx(dumbFeature)('div');

let IconWrp = tx([{element: 'icon-wrapper'}, dumbFeature])('div');

let FeatureItem = tx([{element: 'item'}, dumbFeature])('div');

let HoverWrp = tx([{element: 'hover-wrapper'}, dumbFeature])('div');
let Hover = tx([{element: 'hover'}, dumbFeature])('div');
let HoverLine = tx([{element: 'hover-line'}, dumbFeature])('div');


class _Feature extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    }

    _.bindAll(this, ['trigger', 'wrapHover', 'handleClickOutside'])
  }

  render() {
    return (
      <FeatureWrp>
        <FeatureItem
          onMouseEnter={() => this.trigger('enter')}
          onMouseLeave={() => this.trigger('leave')}
          onClick={() => this.trigger('click')}
        >
          <IconWrp><img src={this.props.icon} alt=''/></IconWrp>
          <span
          >{this.props.name}</span>
        </FeatureItem>
        {
          this.wrapHover(<UnmountClosed
              className='popup'
              isOpened={this.state.hovered && !!this.props.hover}
              springConfig={{stiffness: 400, damping: 25}}
            >
              <HoverLine modifier={this.props.isMobile ? 'mobile' : ''} />
              <Hover>{this.props.hover}</Hover>
            </UnmountClosed>
          )
        }
      </FeatureWrp>
    );
  }

  wrapHover(content) {
    if (this.props.isMobile) {
      return content
    } else {
      return <HoverWrp modifier={this.state.hovered ? 'hover' : ''}>{content}</HoverWrp>
    }
  }

  trigger(event) {
    switch(event) {
      case 'enter': !this.props.isMobile && this.setState({hovered: true}); break;
      case 'leave': !this.props.isMobile && this.setState({hovered: false}); break;
      case 'click': this.props.isMobile && this.setState({hovered: !this.state.hovered}); break;
      default: break;
    }
  }

  handleClickOutside() {
    if (this.props.isMobile) {
      this.setState({hovered: false});
    }
  }
}

export let Feature = clickOutside(_Feature);



// WEBPACK FOOTER //
// ./src/components/landing/pages/pricing/feature/Feature.js